import HeroTradeFloor from "./HeroTradeFloor";
import TpcTradeFloorExperience from "./TpcTradeFloorExperience";
import TpcHostedSessions from "./TpcHostedSessions";
import TpcTradeFloorHostedSessions from "./TpcTradeFloorHostedSessions";
import TpcTradeFloorRooms from "./TpcTradeFloorRooms";
import TpcTradeFloorFacilities from "./TpcTradeFloorFacilities";

function TradeFloor() {
  return (
    <article className="trpc-trade-floor-page">
      <HeroTradeFloor />
      <TpcTradeFloorExperience />
      <TpcTradeFloorRooms />
      <TpcTradeFloorHostedSessions />
      <TpcTradeFloorFacilities />
    </article>
  );
}

export default TradeFloor;